import React from 'react'
import Link from 'gatsby-link'
import Lightbox from 'react-images';
import Gallery from '../../components/Gallery/gallery';
const StudySmartPage = ({ children, location }) => {
    const mockImg = require("../../assets/img/projects/studysmart/frame-mock.png");
    const architectureImg = require("../../assets/img/projects/studysmart/architecture.png");
    const screenshots = [{ src: require("../../assets/img/projects/studysmart/ss/ss1.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss2.png") },
    { src: require("../../assets/img/projects/studysmart/ss/ss3.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss4.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss5.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss6.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss7.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss8.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss9.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss10.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss11.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss12.png") }, { src: require("../../assets/img/projects/studysmart/ss/ss13.jpg") }, { src: require("../../assets/img/projects/studysmart/ss/ss14.jpg") }, { src: require("../../assets/img/projects/studysmart/ss/ss15.jpg") }, { src: require("../../assets/img/projects/studysmart/ss/ss16.jpg") }, { src: require("../../assets/img/projects/studysmart/ss/ss17.jpg") }, { src: require("../../assets/img/projects/studysmart/ss/ss18.jpg") }, { src: require("../../assets/img/projects/studysmart/ss/ss19.jpg") }, { src: require("../../assets/img/projects/studysmart/ss/ss20.jpg") }];
    return (
        <div className="portofolio-project-wrapper ">
            <div className="portofolio-project studysmart ">
                <h1> Study Smart</h1>
                <div className="project-subtitle">
                    <div className="project-status"><span>Status: </span> Completed</div>
                    <div className="project-link"><a href="https://app-study-smart.herokuapp.com/#/" target="_blank">View Application</a></div>
                </div>
                <img src={mockImg} alt="Studysmart Screenshots" />
                <div className="project-section project-intro">
                    <h2>Introduction</h2>
                    <p>
                        The project’s aim wass to develop a platform that brings closer tutors and students, providing an easier way to find suitable tutors/ students, as well as to manage the process of private lessons.  In order to achieve this, three applications were developed: a web application, a mobile application and RESTful Web service, which is consumed by both of the other apps.
                        <br /> <br />
                        This project was submited for the award of Bachelor's degree in Computer Science from University of Southampton.
                        <br />
                        The software was developed in 7 months, during my 3rd university year (October 2015 - April 2016).
                        <br />
                        The full report is available <a href="https://drive.google.com/file/d/1t3_oIqXR-f6bFf-2TB844Ug3t_Q2b-zw/view?usp=sharing" target="_blank"> here</a>.
                    </p>
                    <div className="project-tags">
                        <span>#AngularJS</span>
                        <span>#NodeJS</span>
                        <span>#Ionic</span>
                        <span>#MongoDB</span>
                        <span>#MongoLab</span>
                        <span>#AWS</span>
                        <span>#Heroku</span>
                        <span>#AgileDevelopment</span>
                    </div>
                </div>
                <div className="project-section project-architecture">
                    <h2>Architecture </h2>
                    <img src={architectureImg} alt="Studysmart Architecture" />
                </div>
                <div className="project-section project-features">
                    <h2>Features</h2>
                    <ul>
                        <li><i className="fa fa-check"></i>User Authentication using PassportJS</li>
                        <li><i className="fa fa-check"></i>JWT based Authorization</li>
                        <li><i className="fa fa-check"></i>Push Notifications using Ionic Push</li>
                        <li><i className="fa fa-check"></i>Using MonogLab - MongoDB DBaaS</li>
                        <li><i className="fa fa-check"></i>File uploading (AWS S3)</li>
                        <li><i className="fa fa-check"></i>Web app and the API deployed to Heroku</li>
                    </ul>
                </div>
                <div className="project-section project-screenshots">
                    <h2>Screenshots</h2>
                    <Gallery images={screenshots} />
                </div>
            </div>
        </div>
    )
};

export default StudySmartPage;


// WEBPACK FOOTER //
// ./src/pages/portofolio/studysmart.js